import { render, staticRenderFns } from "./ModalsContainer.vue?vue&type=template&id=1af923b5&scoped=true&"
import script from "./ModalsContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ModalsContainer.vue?vue&type=style&index=0&id=1af923b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af923b5",
  null
  
)

export default component.exports